import { CommonModule, Location } from '@angular/common';
import { BrisbaneDatePipe } from '../../../../shared/pipes/brisbane-date.pipe';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { HttpService } from '../../../../shared/services/http.service';
import { CustomToastComponent } from '../../../../shared/components/toast/custom-toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, finalize } from 'rxjs';
import ApexCharts from 'apexcharts';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddStudentComponent } from '../../../../shared/components/dialog/add-student/add-student.component';
import { AssignStudentsDialogComponent } from '../../../../shared/components/dialog/assign-students/assign-students-dialog.component';
import { AddEventComponent } from '../../../../shared/components/dialog/add-event/add-event.component';
import { TableComponent } from '../../../../shared/components/custom-table/table.component';
import {
  AlertDialogComponent,
  AlertDialogData,
} from '../../../../shared/components/dialog/alert-dialog/alert-dialog.component';
import { SendEmailDialogComponent } from '../../../../shared/components/dialog/send-email/send-email-dialog.component';
import { EventLinkDialogComponent } from '../../../../shared/components/dialog/event-copy-link/event-copy-link-dialog.component';
import { EventManagerFeedbackDialogComponent } from '../../../../shared/components/dialog/event-manager-feedback/event-manager-feedback-dialog.component';
import { CustomRegTableComponent } from '../../../../shared/components/custom-reg-table/custom-reg-table.component';
import { UrlParserService } from '../../../../shared/services/url-parser.service';

interface TeacherDialogData {
  initialData?: APIResponse;
  EditMode: boolean;
  ViewMode: boolean;
  schoolID: string;
  eventId?: string;
  addStudent?: boolean;
}

interface APIResponse {
  status: boolean;
  message: string;
  data: any[] | { [key: string]: any };
}

@Component({
  selector: 'admin-event',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableComponent,
    CustomRegTableComponent,
    BrisbaneDatePipe,
  ],
  templateUrl: './admin-event.component.html',
  styleUrls: ['./admin-event.component.scss'],
})
export class AdminEventComponent implements OnInit, OnDestroy {
  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

  private chart: ApexCharts | null = null;
  adminStudentColumn: string[] = [
    'school name',
    'student name',
    'event status',
    'student status',
    'attended',
    'PD points',
    'media consent',
    'notes',
  ];
  teacheStudentColumn: string[] = [
    'student name',
    'event status',
    'student status',
    'attended',
    'media consent',
    'notes',
  ];
  loginRole: any = '';
  eventSegment: string = '';
  eventData: any = null;
  pageloading: boolean = false;
  loading: boolean = false;
  approvalStatusLoading: boolean = false;
  eventID: any = '';
  showStatusDropdown = false;
  showApprovalStatusDropdown = false;
  statusOptions: any[] = [];
  chartData: {
    registrations: { date: string; registrations: number }[];
    attendenceRate: { attend: number; absent: number };
  } | null = null;
  chartInitialized: boolean = false;
  chartLoading: boolean = false;
  resChartData: any = null;
  engagementMetrics: any = null;
  eventStudentList: any[] = [];
  listViewRoles = {
    shareEmail: false,
    syncWithAsana: false,
    statusChange: false,
    edit: false,
    assignStudent: false,
    studentList: {
      edit: false,
      statusChange: false,
      mediaConsent: false,
    },
  };
  downloadInProgress: boolean = false;
  studentTabelLoading: boolean = false;
  isLoading: boolean = false;
  isFetchingStudentData: boolean = true;
  isUnauthorised: boolean = false;
  isRegistered: boolean = false;
  showConsentButton: boolean = false;
  downloadingRowId: string | null = null;
  private statusDropdownClickListener: (() => void) | null = null;
  private loadingTimeout: any;

  tableData = [
    {
      'school name': 'CPKM HR Sec School',
      'student name': 'Aubrey Scott',
      status: 'Approved',
      'media consent': true,
      attended: true,
      'PD points': '12',
      notes: 'Lorem Ipsum has ido el te...',
    },

    {
      'school name': 'Trevor G. Browne High School',
      'student name': 'Steve Smith',
      'media consent': true,

      status: 'Approved',
      attended: true,
      'PD points': '200',
      notes: 'Lorem Ipsum has ido el te...',
    },
    {
      'school name': 'Trevor G. Browne High School',
      'student name': 'Richard Smith',
      'media consent': true,

      status: 'Approved',
      attended: false,
      'PD points': '100',
      notes: 'Lorem Ipsum has ido el te...',
    },
    {
      'school name': 'CPKM HR Sec School',
      'student name': 'Colleen Brevis',
      status: 'Unapproved',
      'media consent': true,

      attended: false,
      'PD points': '30',
      notes: 'Lorem Ipsum has ido el te...',
    },
    {
      'school name': 'Trevor G. Browne High School',
      'student name': 'Victoria Abby',
      status: 'Approved',
      'media consent': true,

      attended: true,
      'PD points': '50',
      notes: 'Lorem Ipsum has ido el te...',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private location: Location,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router,
    private urlParser: UrlParserService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const encodedSegment = params['segment'];
      this.eventSegment = encodedSegment
        ? this.urlParser.decodeId(encodedSegment)
        : '';
    });

    this.route.paramMap.subscribe((params) => {
      const encodedId = params.get('id');
      this.eventID = encodedId ? this.urlParser.decodeId(encodedId) : null;

      const role = localStorage.getItem('userRole');
      this.loginRole = role;

      if (this.eventID) {
        if (
          this.loginRole === 'superadmin' ||
          this.loginRole === 'teacher' ||
          this.loginRole === 'csquser' ||
          this.loginRole === 'csqadmin'
        ) {
          this.fetchViewEvent(this.eventID);
          this.fetchViewTable(this.eventID);
          this.fetchEventStatus().subscribe();
          this.getEngagementMetrics(this.eventID);
        }

        if (this.loginRole === 'student') {
          this.fetchStudentEventDetails();
        }
      }

      if (
        this.loginRole === 'superadmin' ||
        this.loginRole === 'teacher' ||
        this.loginRole === 'csqadmin' ||
        this.loginRole === 'csquser'
      ) {
        this.listViewRoles.studentList.mediaConsent = true;
      }
    });
  }

  refreshChartData(): void {
    if (
      this.eventID &&
      (this.loginRole === 'superadmin' ||
        this.loginRole === 'teacher' ||
        this.loginRole === 'csquser' ||
        this.loginRole === 'csqadmin')
    ) {
      setTimeout(() => {
        this.fetchChartData(this.eventID);
      }, 500);
    }
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
    setTimeout(() => {
      if (
        this.eventID &&
        (this.loginRole === 'superadmin' ||
          this.loginRole === 'teacher' ||
          this.loginRole === 'csquser' ||
          this.loginRole === 'csqadmin')
      ) {
        this.fetchChartData(this.eventID);
      }
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.removeStatusDropdownClickListener();
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  }

  /// API Calling ////

  fetchViewEvent(id: string): void {
    this.pageloading = true;
    if (!id) {
      this.pageloading = false;
      return;
    }
    this.httpService
      .get<APIResponse>(`events/${id}`)
      .pipe(
        finalize(() => {
          this.loadingTimeout = setTimeout(() => {
            this.pageloading = false;
            this.cdr.detectChanges();
          }, 300);
        }),
      )
      .subscribe({
        next: (response) => {
          if (response.data && !Array.isArray(response.data)) {
            if (response.data) {
              this.eventData = {
                ...response.data,
              };
              // Refresh chart data after event data is loaded
              this.refreshChartData();
            }
          } else {
            this.eventData = null;
          }
        },
        error: (err) => {
          console.error('Failed to load event details:', err);
          this.eventData = null;
          if (
            err?.status === 403 ||
            err?.message === 'You are not authorised to access this page.'
          ) {
            this.router.navigate(['/unauthorized']);
          } else {
            this.showErrorToast(err?.message);
          }
        },
      });
  }

  private fetchStudentEventDetails(): void {
    if (this.eventID) {
      this.isLoading = true;
      this.isFetchingStudentData = true;
      this.httpService
        .get<APIResponse>(`studentdashboard/${this.eventID}`)
        .subscribe({
          next: (response) => {
            if (response?.status) {
              this.eventData = response.data;
              this.isRegistered =
                this.eventData?.isRegistered ||
                !!this.eventData?.registrationStatus;
              this.showConsentButton =
                this.eventData?.isMediaConsentParentApprovalRequired &&
                Number(this.eventData?.studentAge) < 16;
            } else {
              this.showErrorToast(response.message);
            }
            this.isLoading = false;
            this.isFetchingStudentData = false;
          },
          error: (err) => {
            this.isLoading = false;
            this.isFetchingStudentData = false;
            if (
              err?.message === 'You are not authorised to access this page.'
            ) {
              localStorage.removeItem('studentEvent');
              this.router.navigate(['/unauthorized']);
            } else {
              this.showErrorToast(err?.message);
            }
          },
        });
    }
  }

  registerInterest(): void {
    if (this.isRegistered || this.isLoading) return;
    this.isLoading = true;
    this.httpService
      .post<APIResponse>(
        `studenteventregistrations/register/${this.eventID}`,
        {},
      )
      .subscribe({
        next: (response: any) => {
          if (response?.status) {
            this.isRegistered = true;
            this.eventData = {
              ...(this.eventData ?? {}),
              registrationStatus:
                response?.data?.registrationStatus ?? 'Interested',
            };
            localStorage.removeItem('studentEvent');
            this.showSuccessToast(
              response.message || 'Your interest has been registered!',
            );
          } else {
            this.showErrorToast(response.message);
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          this.showErrorToast(error?.message);
          this.isLoading = false;
        },
      });
  }

  fetchEventStatus() {
    return this.httpService.get<any>('events/event-statuses').pipe(
      tap({
        next: (response) => {
          if (Array.isArray(response.data)) {
            this.statusOptions = response.data.map((item: any) => ({
              label: this.normalizeCsqStatusLabel(item.name || item.label),
              value: item.id || item.value,
            }));
          } else {
            this.statusOptions = [];
            this.showErrorToast('Invalid status data format');
          }
        },
        error: (err) => {
          console.error('Failed to load event statuses:', err);
          this.statusOptions = [];
          this.showErrorToast(err?.message);
        },
      }),
    );
  }

  fetchViewTable(id: string): void {
    this.studentTabelLoading = true;
    this.httpService
      .get<APIResponse>(`events/${id}/registrations`)
      .pipe(
        finalize(() => {
          this.studentTabelLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response) => {
          this.eventStudentList = Array.isArray(response?.data)
            ? response.data.map((item) => ({
                id: item.registrationId,
                'school name': item.schoolName || '-',
                'student name': item.studentName || '',
                attended: item.isAttended ?? false,
                'PD points': item.isAttended ? item.pdPoints : '-',
                'media consent': item.isMediaConsentApproved
                  ? item?.isMediaConsentApproved
                  : 'Pending',
                notes: item.notes || '',
                adminStatus: item?.adminApprovalStatus,
                teacherStatus: item?.teacherApprovalStatus,
                status: item?.registrationStatus ?? 'Pending',
                'event status': this.mapEventStatus(item),
                'student status': this.mapStudentStatus(item?.studentStatus, item?.isTeacherVerified ?? false),
                isDownloading: false,
                studentId: item.studentId,
                age: item.studentAge ?? 0,
                isTeacherVerified: item.isTeacherVerified ?? false,
              }))
            : [];
        },
        error: (err) => {
          this.showErrorToast(`Something went wrong. Please try again later.`);
        },
      });
  }

  getEngagementMetrics(id: string) {
    if (!id) {
      return;
    }
    this.httpService
      .get<APIResponse>(`events/${id}/engagement-metrics`)
      .subscribe({
        next: (response) => {
          if (response.data) {
            this.engagementMetrics = response?.data ?? null;
          } else {
            console.error('Failed to load event details:');
          }
        },
        error: (err) => {
          console.error('Failed to load event details:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => (this.loading = false),
      });
  }

  fetchChartData(eventId: string): void {
    this.chartLoading = true;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    this.httpService
      .get<APIResponse>(`events/${eventId}/registration-over-time`)
      .pipe(
        finalize(() => {
          this.chartLoading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response) => {
          const data = response.data as any;
          if (data && data.attendenceRate) {
            this.chartData = {
              registrations: data.registrations || [],
              attendenceRate: data.attendenceRate,
            };
            this.initializeChart();
          } else {
            this.chartData = null;
            this.initializeChart();
          }
        },
        error: (error) => {
          console.error('Failed to load chart data:', error);
          this.chartData = null;
          this.initializeChart();
        },
      });
  }

  useEmptyChartData(): void {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const emptyData = [
      { date: this.formatDateToChartFormat(yesterday), registrations: 0 },
      { date: this.formatDateToChartFormat(today), registrations: 0 },
    ];

    this.updateChartData(emptyData);
  }

  fetchViewEventGraph(id: string): void {
    if (!id) {
      return;
    }

    this.httpService
      .get<APIResponse>(`events/${id}/registration-over-time`)
      .subscribe({
        next: (response) => {
          if (
            response.data &&
            Array.isArray(response.data) &&
            response.data.length > 0
          ) {
            this.resChartData = response.data;
            this.updateChartWithRealData();
          } else {
            this.resChartData = null;
            this.useDummyChartData();
          }
        },
        error: (err) => {
          this.resChartData = null;
          this.useDummyChartData();
          this.showErrorToast(err?.message);
        },
        complete: () => (this.loading = false),
      });
  }

  updateEventStatus(newStatus: any): void {
    const eventStatusId = newStatus.value || newStatus;
    const statusLabel = this.normalizeCsqStatusLabel(
      newStatus?.label || newStatus?.name || newStatus,
    );
    const confirmationMessage =
      this.getStatusChangeConfirmationMessage(statusLabel);

    if (confirmationMessage) {
      this.closeStatusDropdown();
      this.confirmStatusChange(confirmationMessage, () => {
        this.approvalStatusLoading = true;
        this.submitEventStatusUpdate(
          `events/${this.eventData.eventId}/internal-status?eventStatusId=${eventStatusId}`,
          eventStatusId,
          true,
        );
      });
      return;
    }

    this.approvalStatusLoading = true;
    this.submitEventStatusUpdate(
      `events/${this.eventData.eventId}/internal-status?eventStatusId=${eventStatusId}`,
      eventStatusId,
      true,
    );
  }

  private getStatusChangeConfirmationMessage(
    statusLabel: string,
  ): string | null {
    const normalizedStatus = this.normalizeStatusKey(statusLabel);

    switch (normalizedStatus) {
      case 'cancelled':
        return 'Are you sure you want to cancel this event?';
      case 'completed':
        return 'Are you sure you want to complete this event?';
      case 'upcoming':
        return 'Are you sure you want to set this event to Upcoming?';
      case 'on today':
        return 'Are you sure you want to set this event to On Today?';
      case 'already held':
        return 'Are you sure you want to mark this event as Already Held?';
      case 'on hold':
        return 'Are you sure you want to put this event On Hold?';
      default:
        return `Are you sure you want to change the event status to ${statusLabel}?`;
    }
  }

  private confirmStatusChange(message: string, onConfirm: () => void): void {
    const dialogData: AlertDialogData = {
      title: 'Confirm status update',
      message,
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    this.dialog
      .open(AlertDialogComponent, { width: '25.438rem', data: dialogData })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          onConfirm();
        }
      });
  }

  private submitEventStatusUpdate(
    endpoint: string,
    eventStatusId: any,
    allowFallback: boolean,
  ): void {
    this.httpService.put<APIResponse>(endpoint, '').subscribe({
      next: (response) => {
        if (response.status) {
          this.showSuccessToast(response?.message);
          this.fetchViewEvent(this.eventID);
          // Refresh chart data after status update
          this.refreshChartData();
          this.closeStatusDropdown();
        } else {
          this.showErrorToast(
            response.message || 'Something went wrong. Please try again later.',
          );
        }

        this.approvalStatusLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        if (allowFallback && error?.status === 404) {
          this.submitEventStatusUpdate(
            `events/${this.eventData.eventId}/toggle-status?eventStatusId=${eventStatusId}`,
            eventStatusId,
            false,
          );
          return;
        }

        console.error('Status update error:', error?.message);
        this.showErrorToast(
          error?.message || 'Something went wrong. Please try again later.',
        );
        this.approvalStatusLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  getStatusClass(status: any): string {
    if (!status) return '';
    const normalizedStatus = String(status).trim().toLowerCase();
    if (normalizedStatus === 'upcoming' && this.isEventInPast()) {
      return 'completed-text';
    }
    switch (normalizedStatus) {
      case 'draft':
        return 'status-draft';
      case 'ongoing':
      case 'on today':
      case 'in progress':
      case 'progressing':
        return 'status-on-today';
      case 'upcoming':
        return 'status-upcoming';
      case 'already held':
      case 'alreadyheld':
      case 'completed':
      case 'event completed':
      case 'eventcompleted':
        return 'completed-text';
      case 'onhold':
      case 'on hold':
        return 'status-on-hold';
      case 'cancelled':
      case 'event cancelled':
      case 'eventcancelled':
      case 'deleted':
        return 'cancelled-text';
      default:
        return 'pending-text';
    }
  }

  getStatusOptionClass(status: any): string {
    return this.getStatusClass(status);
  }

  getFocusAreaNames(): string {
    return (
      this.eventData?.focusAreas
        ?.map((area: any) => area.focusAreaName)
        .join(', ') || '-'
    );
  }

  getManagersNames(): string {
    return (
      this.eventData?.managers
        ?.map((manger: any) => manger.firstName + ' ' + manger.lastName)
        .join(', ') || '-'
    );
  }

  getEventManagerName(): string {
    const firstManager = this.eventData?.managers?.[0];
    if (!firstManager) {
      return '-';
    }

    return `${firstManager.firstName || ''} ${firstManager.lastName || ''}`.trim();
  }

  hasEventManagerFeedback(): boolean {
    return !!String(this.eventData?.eventManagerFeedback || '').trim();
  }

  canEditEventManagerFeedback(): boolean {
    return !!this.eventData?.canEditEventManagerFeedback;
  }

  getEventManagerFeedbackAuthor(): string {
    return (
      this.eventData?.eventManagerFeedbackUpdatedByName ||
      this.getEventManagerName()
    );
  }

  getFeedbackButtonLabel(): string {
    if (this.hasEventManagerFeedback()) {
      return 'View feedback';
    }

    return 'Add your feedback';
  }

  isFeedbackButtonDisabled(): boolean {
    return (
      !this.hasEventManagerFeedback() && !this.canEditEventManagerFeedback()
    );
  }

  isFeedbackVisible(): boolean {
    const status = this.normalizeStatusKey(this.eventData?.eventStatus);
    if (
      status === 'draft' ||
      status === 'upcoming' ||
      status === 'on hold' ||
      status === 'event cancelled'
    ) {
      return false;
    }
    if (status === 'deleted') {
      return this.loginRole === 'superadmin';
    }

    return true;
  }

  getMCCpartnersNames(): string {
    return (
      this.eventData?.mccPartners
        ?.map((manger: any) => manger.mccEventPartnerName)
        .join(', ') || '-'
    );
  }

  private isEventInPast(): boolean {
    if (!this.eventData?.eventEndDate) return false;
    const endDate = new Date(this.eventData.eventEndDate);
    endDate.setHours(23, 59, 59, 999);
    return endDate < new Date();
  }

  getStatusDisplayValue(statusValue: any): string {
    if (!statusValue) return 'Pending';

    const statusArray = this.statusOptions;
    const status = statusArray.find(
      (opt) =>
        opt.value === statusValue ||
        opt.label === statusValue ||
        opt.id === statusValue,
    );

    const label = this.normalizeCsqStatusLabel(
      status?.label || statusValue || 'Pending',
    );

    if (label.toLowerCase() === 'upcoming' && this.isEventInPast()) {
      return 'Already Held';
    }

    return label;
  }

  toggleStatusDropdown(event: Event): void {
    if (!this.canChangeEventStatus()) {
      return;
    }

    event.stopPropagation();
    this.showStatusDropdown = !this.showStatusDropdown;
    if (this.showStatusDropdown) {
      this.addStatusDropdownClickListener();
    } else {
      this.removeStatusDropdownClickListener();
    }
    this.cdr.detectChanges();
  }

  onToggleChange(event: { row: any; checked: boolean }): void {
    const { row, checked } = event;
    const originalState = row.attended;

    const dialogData: AlertDialogData = {
      title: 'Confirm attendance update',
      message: checked
        ? 'Do you want to mark this student as Attended?'
        : 'Do you want to mark this student as Not Attended?',
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      const payload = { isAttended: checked };

      this.httpService
        .put<APIResponse>(`teacherevent/${row?.id}/attendance`, payload)
        .subscribe({
          next: (response) => {
            if (response.status) {
              row.attended = checked;
              this.fetchViewTable(this.eventID);
              this.getEngagementMetrics(this.eventID);
              this.fetchChartData(this.eventID);
              this.cdr.detectChanges();
              this.showSuccessToast(response.message);
            } else {
              this.showErrorToast(response.message);
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message || 'Failed to update attendance');
          },
        });
    });
  }

  onDownloadConsent(event: { row: any; id: boolean }): void {
    if (!this.listViewRoles.studentList.mediaConsent) {
      this.showErrorToast(
        'You do not have permission to download media consent',
      );
      return;
    }

    const { row } = event;

    this.downloadingRowId = row.id;
    this.downloadInProgress = true;
    this.updateRowDownloadingState(row.id, true);
    this.showInfoToast('Preparing download…');

    this.httpService
      .download(
        this.loginRole === 'teacher'
          ? `teacherevent/registrations/${row?.id}/media-consent/pdf`
          : `events/registrations/${row?.id}/media-consent/pdf`,
      )
      .pipe(
        finalize(() => {
          this.clearDownloadingState(row.id);
        }),
      )
      .subscribe({
        next: (res) => {
          const blob = res.body;
          if (!blob || blob.size === 0) {
            this.showErrorToast('Empty PDF received');
            return;
          }

          if (
            blob.type &&
            !blob.type.includes('pdf') &&
            !blob.type.includes('application/octet-stream')
          ) {
            this.showErrorToast('Invalid file format received');
            return;
          }

          const contentDisposition =
            res.headers.get('content-disposition') || '';
          const filename =
            this.extractFilename(contentDisposition) ||
            `media-consent-${row?.id}.pdf`;

          this.triggerDownload(blob, filename);
          this.showSuccessToast('Media Consent downloaded successfully!');
        },
        error: (err) => {
          console.error('Download error:', err);

          if (err.error && err.error instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorResponse = JSON.parse(reader.result as string);
                this.showErrorToast(
                  errorResponse?.message || 'Failed to download PDF',
                );
              } catch {
                this.showErrorToast(err?.message || 'Failed to download PDF');
              }
            };
            reader.readAsText(err.error);
          } else {
            this.showErrorToast(err?.message || 'Failed to download PDF');
          }
        },
      });
  }

  onMediaConsentToggle(event: { row: any; checked: boolean }): void {
    const { row, checked } = event;
    const studentId = row.studentId;
    if (!studentId) return;

    const newStatus = checked ? 'Approved' : 'Declined';
    const dialogData: AlertDialogData = {
      title: 'Update Media Consent',
      message: `Are you sure you want to set Media Consent to ${newStatus} for this student?`,
      okText: 'Confirm',
      cancelText: 'Cancel',
      okButtonColor: 'var(--blue-color)',
      cancelButtonColor: '#e74c3c',
      submessage: '',
      icon: 'warning',
    };

    this.dialog
      .open(AlertDialogComponent, { width: '25.438rem', data: dialogData })
      .afterClosed()
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.httpService
          .put<APIResponse>(`students/${studentId}/media-consent/manual-update`, { approved: checked })
          .subscribe({
            next: (response) => {
              if (response.status) {
                this.showSuccessToast(response.message || `Media consent set to ${newStatus}.`);
                this.fetchViewTable(this.eventID);
              } else {
                this.showErrorToast(response.message || 'Failed to update media consent.');
              }
            },
            error: (err) => {
              this.showErrorToast(err?.message || 'Failed to update media consent.');
            },
          });
      });
  }

  private clearDownloadingState(rowId?: string): void {
    this.downloadInProgress = false;
    if (rowId) {
      this.updateRowDownloadingState(rowId, false);
    }
    this.downloadingRowId = null;
  }

  private updateRowDownloadingState(
    rowId: string,
    isDownloading: boolean,
  ): void {
    const studentIndex = this.eventStudentList.findIndex(
      (item) => item.id === rowId,
    );
    if (studentIndex !== -1) {
      this.eventStudentList[studentIndex].isDownloading = isDownloading;
    }
  }

  private extractFilename(cd: string): string | null {
    if (!cd) return null;
    const filenameMatch = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (filenameMatch && filenameMatch[1]) {
      return filenameMatch[1].replace(/['"]/g, '');
    }
    return null;
  }

  private triggerDownload(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  onNoteUpdate(event: any): void {
    const payload = {
      notes: event?.notes ?? '',
    };

    this.httpService
      .put<APIResponse>(`events/${event?.row?.id}/adminnotes`, payload)
      .subscribe({
        next: (response) => {
          if (response.status) {
            this.showSuccessToast(response?.message);
            this.fetchViewTable(this.eventID);
            this.getEngagementMetrics(this.eventID);
          } else {
            this.showErrorToast(response?.message);
          }
        },
        error: (error) => {
          console.error('Note update error:', error?.message);
          this.showErrorToast(
            error?.message || 'Something went wrong. Please try again later.',
          );
        },
      });
  }

  onAdminEventStatusChange(event: { row: any; newStatus: string }): void {
    const { row, newStatus } = event;

    const statusMap: Record<string, string> = {
      Interested: 'interested',
      Approved: 'approved',
      Unapproved: 'rejected',
    };
    const apiStatus = statusMap[newStatus] ?? newStatus;

    const dialogData: AlertDialogData = {
      title: 'Confirm status change',
      message: `Change event status to "${newStatus}"?`,
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return;
      this.httpService
        .put<APIResponse>(`teacherevent/${row?.id}/approval`, {
          Status: apiStatus,
        })
        .subscribe({
          next: (response) => {
            if (response?.status) {
              this.fetchViewTable(this.eventID);
              this.fetchChartData(this.eventID);
              this.showSuccessToast(response.message);
            } else {
              this.showErrorToast(
                response?.message ?? 'Failed to update status.',
              );
            }
          },
          error: (err) =>
            this.showErrorToast(err?.message ?? 'Failed to update status.'),
        });
    });
  }

  onStudentStatusChange(event: { row: any; newStatus: string }): void {
    const { row, newStatus } = event;

    const statusMap: Record<string, string> = {
      Interested: 'interested',
      Approved: 'approved',
      Unapproved: 'rejected',
    };

    const apiStatus = statusMap[newStatus];
    if (!apiStatus) return;

    const dialogData: AlertDialogData = {
      title: 'Confirm status change',
      message: `Change event status to "${newStatus}"?`,
      okText: 'Yes',
      cancelText: 'No',
      icon: 'warning',
      submessage: '',
      cancelButtonColor: '#EF4A00',
      okButtonColor: '#5BD763',
    };

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '25.438rem',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      this.httpService
        .put<APIResponse>(`teacherevent/${row?.id}/approval`, {
          Status: apiStatus,
        })
        .subscribe({
          next: (response) => {
            if (response.status) {
              this.fetchViewTable(this.eventID);
              this.showSuccessToast(response.message);
            } else {
              this.showErrorToast(response.message);
            }
          },
          error: (err) => {
            this.showErrorToast(err?.message || 'Failed to update status');
          },
        });
    });
  }

  initializeChart(): void {
    if (!this.chartContainer?.nativeElement) {
      setTimeout(() => this.initializeChart(), 100);
      return;
    }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    const attendenceRate = this.chartData?.attendenceRate || {
      attend: 0,
      absent: 100,
    };
    const attend = attendenceRate.attend ?? 0;
    const absent = attendenceRate.absent ?? 100;

    const hasData = attend > 0 || absent > 0;

    const options: ApexCharts.ApexOptions = {
      series: hasData ? [attend, absent] : [1],
      labels: hasData ? ['Attended', 'Absent'] : ['No Data'],
      chart: {
        type: 'donut',
        height: 250,
        toolbar: { show: false },
        background: 'transparent',
        fontFamily: 'inherit',
        animations: {
          enabled: true,
          speed: 800,
        },
      },
      colors: hasData ? ['#50b748', '#faa633'] : ['#faa633'],
      dataLabels: { enabled: false },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          donut: {
            size: '70%',
            labels: {
              show: true,
              name: {
                show: false,
              },
              value: {
                show: true,
                fontSize: '22px',
                fontWeight: 700,
                color: '#ffffff',
                offsetY: 6,
                formatter: (val: string) => `${val}%`,
              },
              total: {
                show: true,
                showAlways: true,
                label: 'Attend',
                fontSize: '13px',
                fontWeight: 600,
                color: '#9CA3AF',
                formatter: () => `${attend}%`,
              },
            },
          },
        },
      },
      legend: {
        show: hasData,
        position: 'bottom',
        labels: {
          colors: '#9CA3AF',
        },
        markers: {
          offsetX: -4,
          strokeWidth: 0,
          fillColors: ['#50b748', '#faa633'],
        },
        itemMargin: {
          horizontal: 10,
          vertical: 6,
        },
        offsetY: 6,
      },
      tooltip: {
        enabled: hasData,
        theme: 'dark',
        y: {
          formatter: (value: number) => `${value}%`,
        },
        style: { fontSize: '12px' },
      },
    };

    try {
      this.chart = new ApexCharts(this.chartContainer.nativeElement, options);
      this.chart
        .render()
        .then(() => {
          this.chartInitialized = true;
          this.chartLoading = false;
          this.cdr.detectChanges();
        })
        .catch((error) => {
          console.error('Chart rendering failed:', error);
          this.chartLoading = false;
          this.cdr.detectChanges();
        });
    } catch (error) {
      console.error('Chart initialization failed:', error);
      this.chartLoading = false;
      this.cdr.detectChanges();
    }
  }

  updateChartData(newData: { date: string; registrations: number }[]): void {
    this.initializeChart();
  }

  updateChartWithRealData(): void {
    this.initializeChart();
  }

  formatDateToChartFormat(date: Date): string {
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
    });
  }

  formatChartDate(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString.split('T')[0];
      }

      return date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'short',
      });
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return dateString.split('T')[0];
    }
  }

  useDummyChartData(): void {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const dummyData = [
      { date: this.formatDateToChartFormat(yesterday), registrations: 0 },
      { date: this.formatDateToChartFormat(today), registrations: 0 },
    ];

    this.updateChartData(dummyData);
  }

  openAddStudentDialog(
    teacherToEdit: APIResponse | undefined = undefined,
    isEdit = false,
    width = '50.5rem',
  ): void {
    const schoolID =
      teacherToEdit &&
      typeof teacherToEdit === 'object' &&
      'schools' in teacherToEdit
        ? (teacherToEdit as any)?.schools?.[0]?.schoolId
        : this.eventID;

    const dialogConfig: MatDialogConfig<TeacherDialogData> = {
      width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: {
        initialData: teacherToEdit,
        EditMode: isEdit,
        schoolID: schoolID,
        eventId: this.eventID,
        addStudent: true,
        ViewMode: false,
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    };

    this.dialog
      .open(AddStudentComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.fetchViewTable(this.eventID);
          this.getEngagementMetrics(this.eventID);
        }
      });
  }

  openAssignStudentsDialog(): void {
    const dialogConfig: MatDialogConfig = {
      width: '40rem',
      maxWidth: '95vw',
      minWidth: '300px',
      data: { eventId: this.eventID },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    };

    this.dialog
      .open(AssignStudentsDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.fetchViewTable(this.eventID);
          this.getEngagementMetrics(this.eventID);
        }
      });
  }

  private mapEventStatus(item: any): string {
    const status = item?.registrationStatus;

    const map: Record<string, string> = {
      Interested: 'Interested',
      TeacherReviewPending: 'Interested',
      TeacherApproved: 'Approved',
      AdminApproved: 'Approved',
      TeacherRejected: 'Unapproved',
    };

    return map[status] ?? 'Interested';
  }

  private mapStudentStatus(studentStatus: string | null | undefined, isTeacherVerified: boolean = false): string {
    const map: Record<string, string> = {
      NewNonOnboarded: 'New Non Onboarded',
      'New Non Onboarded': 'New Non Onboarded',
      PendingConsent: 'Pending Consent',
      'Pending Consent': 'Pending Consent',
      PreRegistered: 'Pre Registered',
      'Pre Registered': 'Pre Registered',
      Registered: 'Registered',
      ConsentDeclined: 'Parent Declined',
      'Consent Declined': 'Parent Declined',
    };

    const mapped = map[studentStatus ?? ''] ?? studentStatus ?? '-';

    if (mapped === 'New Non Onboarded' && !isTeacherVerified) {
      return 'Pending Verification';
    }

    return mapped;
  }

  goBack() {
    const studentEvent = localStorage.getItem('studentEvent');
    if (studentEvent && this.loginRole === 'student') {
      this.router.navigate(['/dashboard/user']);
    } else {
      this.location.back();
    }
  }

  onEdit(data: any): void {
    if (!this.canEditCurrentEvent()) {
      this.showErrorToast(
        this.normalizeStatusKey(this.eventData?.eventStatus) === 'deleted'
          ? 'Deleted events are view only.'
          : 'Only Super Admin can edit completed events.',
      );
      return;
    }

    const dialogRef = this.openAddDialog(data, true);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.success) {
        this.refreshChartData();
      }
    });
  }

  canEditCurrentEvent(): boolean {
    const normalizedStatus = this.normalizeStatusKey(
      this.eventData?.eventStatus,
    );
    if (normalizedStatus === 'deleted') {
      return this.loginRole === 'superadmin';
    }

    if (
      normalizedStatus === 'completed' ||
      normalizedStatus === 'event completed'
    ) {
      return this.loginRole === 'superadmin';
    }

    if (normalizedStatus === 'event cancelled') {
      return (
        this.loginRole === 'superadmin' ||
        this.loginRole === 'csqadmin' ||
        this.loginRole === 'csquser'
      );
    }

    return true;
  }

  canChangeEventStatus(): boolean {
    if (
      !this.eventData?.eventStatus ||
      this.eventData?.eventStatus === 'Draft'
    ) {
      return false;
    }

    const normalizedStatus = this.normalizeStatusKey(
      this.eventData?.eventStatus,
    );
    if (normalizedStatus === 'deleted') {
      return false;
    }

    if (
      normalizedStatus === 'completed' ||
      normalizedStatus === 'event completed'
    ) {
      return this.loginRole === 'superadmin';
    }

    return true;
  }

  private normalizeCsqStatusLabel(status: any): string {
    const normalizedStatus = this.normalizeStatusKey(status);

    switch (normalizedStatus) {
      case 'ongoing':
      case 'in progress':
      case 'progressing':
        return 'On Today';
      case 'completed':
      case 'event completed':
        return 'Completed';
      case 'cancelled':
      case 'event cancelled':
        return 'Cancelled';
      default:
        return status || 'Pending';
    }
  }

  private normalizeStatusKey(status: any): string {
    return String(status || '')
      .trim()
      .toLowerCase();
  }

  openAddDialog(
    schoolToEdit: any = null,
    isEdit: boolean = false,
    width: string = '54.5rem',
  ): any {
    const dialogRef = this.dialog.open(AddEventComponent, {
      width: width,
      maxWidth: '90vw',
      minWidth: '300px',
      data: { initialData: schoolToEdit, EditMode: isEdit },
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.fetchViewEvent(this.eventID);
        this.refreshChartData();
      }
    });

    return dialogRef;
  }

  private addStatusDropdownClickListener(): void {
    this.removeStatusDropdownClickListener();
    this.statusDropdownClickListener = () => {
      this.closeStatusDropdown();
    };
    setTimeout(() => {
      document.addEventListener('click', this.statusDropdownClickListener!);
    }, 0);
  }

  private removeStatusDropdownClickListener(): void {
    if (this.statusDropdownClickListener) {
      document.removeEventListener('click', this.statusDropdownClickListener);
      this.statusDropdownClickListener = null;
    }
  }

  closeStatusDropdown(): void {
    if (this.showStatusDropdown || this.showApprovalStatusDropdown) {
      this.showStatusDropdown = false;
      this.showApprovalStatusDropdown = false;
      this.removeStatusDropdownClickListener();
      this.cdr.markForCheck();
    }
  }

  openCopyLink(width = '50.5rem', initialData?: {}): void {
    const dialogConfig: MatDialogConfig<any> = {
      width: width,
      maxWidth: window.innerWidth <= 740 ? '' : '750px',
      minWidth: window.innerWidth <= 740 ? '100%' : '750px',
      maxHeight: '90vh',
      height: 'auto',
      data: {
        eventData: this.eventData,
        eventId: this.eventID,
        studentShare: this.loginRole === 'teacher' ? true : false,
      },
      disableClose: true,
      autoFocus: false,
      backdropClass: 'blur-backdrop',
      hasBackdrop: true,
      panelClass: ['blur-backdrop-dialog', 'responsive-dialog'],
    };

    try {
      const dialogRef = this.dialog.open(
        EventLinkDialogComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.success) {
        }
      });
    } catch (error) {
      console.error('Error opening dialog:', error);
    }
  }

  addFeedBack(width = '50.5rem', initialData?: {}): void {
    const dialogConfig: MatDialogConfig<any> = {
      width: width,
      maxWidth: '90vw',
      minWidth: '300px',
      maxHeight: '90vh',
      height: 'auto',
      data: {
        eventId: this.eventID,
        feedback: this.eventData?.eventManagerFeedback || '',
        eventManagerName: this.getEventManagerName(),
        canEdit: this.canEditEventManagerFeedback(),
        updatedAt: this.eventData?.eventManagerFeedbackUpdatedAt,
        updatedByName: this.getEventManagerFeedbackAuthor(),
      },
      disableClose: true,
      autoFocus: false,
      backdropClass: 'blur-backdrop',
      hasBackdrop: true,
      panelClass: 'blur-backdrop-dialog',
    };

    try {
      const dialogRef = this.dialog.open(
        EventManagerFeedbackDialogComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.success) {
          this.fetchViewEvent(this.eventID);
        }
      });
    } catch (error) {
      console.error('Error opening dialog:', error);
    }
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'success-toast'],
    });
  }

  private showErrorToast(message: string | null | undefined): void {
    if (!message) return;
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'error-toast'],
    });
  }

  private showInfoToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 4000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'info-toast'],
    });
  }

  onView(data: any): void {
    const studentID = data?.studentId;
    this.router.navigate([`/students/view/${studentID}`]);
  }

  exportStudentsToCSV(): void {
    if (!this.eventStudentList.length) return;

    const headers = [
      'School Name',
      'Student Name',
      'Event Status',
      'Student Status',
      'Attended',
      'PD Points',
      'Media Consent',
      'Notes',
    ];

    const rows = this.eventStudentList.map((s) => [
      s['school name'] ?? '',
      s['student name'] ?? '',
      s['event status'] ?? '',
      s['student status'] ?? '',
      s['attended'] === true ? 'Yes' : s['attended'] === false ? 'No' : '',
      s['PD points'] ?? '',
      s['media consent'] ?? '',
      s['notes'] ?? '',
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((cell) => {
            const val = String(cell ?? '').replace(/"/g, '""');
            return `"${val}"`;
          })
          .join(','),
      )
      .join('\r\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const eventName = (this.eventData?.eventName ?? 'event')
      .replace(/[^a-z0-9]/gi, '_')
      .toLowerCase();
    this.triggerDownload(blob, `${eventName}_students.csv`);
  }
}
